import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=fafccb38&scoped=true&"
import script from "./Legal.ts?vue&type=script&lang=ts&"
export * from "./Legal.ts?vue&type=script&lang=ts&"
import style0 from "./Legal.vue?vue&type=style&index=0&id=fafccb38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafccb38",
  null
  
)

export default component.exports